/* tslint:disable */

/**
 */
export class SettingGlobal {
    key?: string;
    value?: string;
}
